<template>
  <div
    :class="[
      'ui-field',
      {
        'ui-field--error': error,
        'ui-field--focused': focused,
        'ui-field--disabled': disabled,
      },
    ]"
  >
    <input
      class="ui-field__input text-body"
      :type="inputType"
      :placeholder="label"
      :disabled="disabled"
      :autocomplete="autocomplete"
      :value="value"
      @input="onInput"
      @focus="focused = true"
      @blur="focused = false"
    />
    <button
      v-if="type === 'password'"
      type="button"
      class="ui-field__eye"
      tabindex="-1"
      @click="showPassword = !showPassword"
    >
      <!-- Eye open -->
      <svg
        v-if="showPassword"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
      <!-- Eye closed -->
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"
        />
        <path
          d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"
        />
        <line x1="1" y1="1" x2="23" y2="23" />
      </svg>
    </button>
    <p v-if="error && errorMessage" class="ui-field__error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: "UITextField",
  props: {
    label: {
      type: String,
      required: true,
    },
    // 'text' | 'email' | 'password' | 'number' | etc.
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "энэ нүдийг бөглөнө үү",
    },
    autocomplete: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      focused: false,
      showPassword: false,
    };
  },
  computed: {
    inputType() {
      if (this.type === "password") {
        return this.showPassword ? "text" : "password";
      }
      return this.type;
    },
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
    },
  },
};
</script>

<style scoped>
.ui-field {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.ui-field__input {
  display: block;
  width: 100%;
  height: 40px;
  padding: 0 10px;
  font-size: 15px;
  font-weight: 400;
  color: #1a1a2e;
  background-color: #ffffff;
  border: 1.5px solid #d0d5e0;
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.ui-field__input::placeholder {
  color: #9ea8c0;
}

/* No trailing icon — less padding */
.ui-field__input:only-child {
  padding-right: 18px;
}

/* Focused */
.ui-field--focused .ui-field__input {
  border-color: #2d3f9c;
  box-shadow: 0 0 0 3px rgba(45, 63, 156, 0.1);
}

/* Error */
.ui-field--error .ui-field__input {
  border-color: #e03131;
  box-shadow: 0 0 0 3px rgba(224, 49, 49, 0.1);
}

/* Disabled */
.ui-field--disabled .ui-field__input {
  background-color: #f4f6fb;
  color: #9ea8c0;
  cursor: not-allowed;
}

/* Eye toggle */
.ui-field__eye {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #9ea8c0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s ease;
  line-height: 0;
}
.ui-field__eye:hover {
  color: #2d3f9c;
}

/* Error message */
.ui-field__error {
  margin: 6px 4px 0;
  font-size: 12px;
  color: #e03131;
}
</style>
